import { render } from "./InterfaceIntegratedEditorNavigation.vue?vue&type=template&id=8aceb4e0&scoped=true"
import script from "./InterfaceIntegratedEditorNavigation.vue?vue&type=script&lang=js"
export * from "./InterfaceIntegratedEditorNavigation.vue?vue&type=script&lang=js"

import "./InterfaceIntegratedEditorNavigation.vue?vue&type=style&index=0&id=8aceb4e0&scoped=true&lang=scss"

import exportComponent from "/tmp/ef98a231-0263-404c-a747-c31ac6c86af7/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8aceb4e0"]])

export default __exports__